import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';
import { useTranslator } from '@/hooks/useTranslator';
import { InvolvedOrdersTable } from '../../../-components/InvolvedOrdersTable';

/**
 * The purchase orders a screened company takes part in.
 *
 * Reached from the screening list's "orders involved" count, which used to point
 * at the bare sales-order list — a page that knew nothing about the company and
 * answered a different question. The old dashboard keeps this at
 * `/involved-orders/:companyId`; here it sits under the feature that links to
 * it.
 */
export const Route = createFileRoute(
  '/(client)/entity-screening/(pages)/involved-orders/$companyId/',
)({
  component: InvolvedOrdersPage,
});

function InvolvedOrdersPage() {
  const { companyId } = Route.useParams();
  const { getTranslation: t } = useTranslator({ page: 'entityScreening' });

  return (
    <PageContainer>
      <div className='flex flex-col gap-0.5 pb-3'>
        <h1 className='text-sm font-semibold text-foreground leading-tight'>
          {t('involvedOrders.title')}
        </h1>
        <p className='text-xs text-muted-foreground'>
          {t('involvedOrders.subtitle')}
        </p>
      </div>
      <InvolvedOrdersTable companyId={companyId} />
    </PageContainer>
  );
}
